var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:[
    _vm.icon,
    'app-icon',
    `fa-${_vm.size}`,
    {
      [`is-${_vm.type}`]: _vm.type,
      'no-branding': _vm.noBranding,
    },
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }